import { IconX } from './Icons';

// `dismissable={false}` evita cerrar por error un formulario largo al hacer
// clic fuera del panel: en ese caso solo cierran la X y los botones del modal.
export default function Modal({ open, title, subtitle, size = 'md', dismissable = true, onClose, children }) {
  if (!open) return null;
  return (
    <div
      className="modal-backdrop fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={dismissable ? onClose : undefined}
    >
      <div
        className={`modal-panel max-h-[92vh] w-full overflow-y-auto ${size === 'lg' ? 'max-w-4xl' : 'max-w-xl'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button onClick={onClose} className="modal-close" aria-label="Cerrar">
            <IconX size={20} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
